/* eslint-disable functional/prefer-readonly-type */
import { createState, useState } from '@hookstate/core'

type InterestPointRowUpdate = {
  readonly id: number
  readonly expiration_date: string | null
} | null

const interestPointRefreshState = createState<boolean>(false)
const interestPointRowUpdateState = createState<InterestPointRowUpdate>(null)

const fetchCallbackRef: { current: (() => void) | null } = { current: null }

export default function useInterestPointState() {
  const refreshInterestPoint = useState(interestPointRefreshState)
  const interestPointRowUpdate = useState(interestPointRowUpdateState)

  const registerFetchCallback = (callback: (() => void) | null) => {
    fetchCallbackRef.current = callback
  }

  const reloadInterestPointList = () => {
    if (fetchCallbackRef.current) {
      fetchCallbackRef.current()
    } else {
      refreshInterestPoint.set(!refreshInterestPoint.get())
    }
  }

  const updateInterestPointRow = (update: InterestPointRowUpdate) => {
    interestPointRowUpdate.set(update)
  }

  return {
    refreshInterestPoint,
    reloadInterestPointList,
    interestPointRowUpdate,
    updateInterestPointRow,
    registerFetchCallback,
  }
}
